import React, { useEffect } from "react";
import "./AddedToCartModal.css";
import { Button, Modal } from "react-bootstrap";
import Added_To_Cart_Lottie from "../../../Animation/Added_To_Cart_Lottie/Added_To_Cart_Lottie";
import Orange_Round_Arrow_Btn from "../../Common_Btn/Orange_Round_Arrow_Btn/Orange_Round_Arrow_Btn";
import { Link } from "react-router-dom";

function AddedToCartModal({ baseLink, ...props }) {
  //   setTimeout(() => {
  //     props?.onHide();
  //   }, 5000);

  return (
    <>
      <section className="AddedToCartModal modal-holder">
        <Modal
          {...props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="AddedToCartModal modal-holder"
        >
          <Modal.Body>
            <div className="main_div">
              <div className="success_loottie_holder">
                <Added_To_Cart_Lottie />
              </div>

              <div className="text_holder">
                <p className="text">The Product Added To</p>
                <p className="text">The Cart Successfully!</p>
              </div>
              <Link to="/order-process" onClick={props.onHide}>
                <div className="view_cart_btn">
                  <Orange_Round_Arrow_Btn btn_name="View Cart" />
                </div>
              </Link>
            </div>
          </Modal.Body>
        </Modal>
      </section>
    </>
  );
}

export default AddedToCartModal;
